import apiUrl from "./config/config";
import axios from "axios";

class productCategoryApi {

  static async getProductCategories(params)
  {

    try
    {

      const response = await axios(apiUrl + "productcategory", {params});

      return response.data;

      // while(true){

      //   const response = await axios(apiUrl + "productCategory", {params});

      // }

    } catch (err)
    {

      throw new Error();

    }

  }

  static async getProductCategory(id = "")
  {

    try
    {

      const response = await axios(apiUrl + "productcategory/" + id);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

}







export default productCategoryApi;
